import {useStore} from '../../store'
import {DateNavigator} from './DateNavigator'

interface DayDateBtnProps {
  selectedDate: Date
  onChange(value: Date, key: 'selectedDate'): void
}

const DayDateBtn = ({selectedDate, onChange}: DayDateBtnProps) => {
  const {week} = useStore()
  return (
    <DateNavigator
      unit='day'
      selectedDate={selectedDate}
      weekStartOn={week!.weekStartOn}
      onChange={onChange}
    />
  )
}

export {DayDateBtn}
